import { useDispatch } from 'react-redux';
import { trackScreenView, trackScreenDimensions } from 'lib/Tracking';
import { loadMakesAndModels } from 'redux-implementations/makesAndModels';
import { AppDispatch } from 'redux-implementations/makeStore';
import Hero from 'components/Home/Hero';
import TrendingSearches from 'components/Home/TrendingSearches';
import BodyTypesSearches from 'components/Home/BodyTypesSearches';
import PopularSearches from 'components/Home/PopularSearches';
import WhyAutolist from 'components/Home/WhyAutolist';
import PhotoCredits from 'components/Home/PhotoCredits';
import Ad from 'components/Ad';
import Price from 'components/Home/Price';
import CitiesSearches from 'components/Home/CitiesSearches';
import TopModelsByYear from 'components/Home/TopModelsByYear';
import TopModelsByCity from 'components/Home/TopModelsByCity';
import MobileAppDownload from 'components/Home/MobileAppDownload';
import { LARGE, MEDIUM, SMALL, X_SMALL } from 'lib/DeviceScreen';
import adCSS from 'components/styles/CenteredAd';
import { LEADERBOARD, MEDIUM_RECTANGLE } from 'lib/GoogleAds/Sizes';
import { useEffect } from 'react';
import { screen } from 'components/styles/variables';
import FacebookPixel from 'lib/FacebookPixel';

const adConfig = {
  dimensions: [
    [320, 50],
    [300, 250],
  ],
  targeting: { inLine: 2 },
  screenSizes: [SMALL, X_SMALL],
};

export default function Home(): JSX.Element {
  useEffect(() => {
    trackScreenView({ page: 'home_page' });
    trackScreenDimensions({ category: 'home_page' });
    FacebookPixel.trackPageView();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(loadMakesAndModels());
  }, [dispatch]);

  return (
    <>
      <Hero />
      <div className="ad-container">
        <Ad
          adConfig={{
            dimensions: [[728, 90]],
            targeting: { inLine: 1 },
            screenSizes: [LARGE, MEDIUM, SMALL],
          }}
          placeholderSize={LEADERBOARD}
          className={`${adCSS.className}`}
        />
      </div>
      <MobileAppDownload />
      <TrendingSearches />
      <div className={`ad ${adCSS.className}`}>
        <Ad
          adConfig={adConfig}
          placeholderSize={MEDIUM_RECTANGLE}
          className={`${adCSS.className} with-auto-margin`}
        />
      </div>
      <Price />
      <BodyTypesSearches />
      <PopularSearches />
      <CitiesSearches />
      <TopModelsByYear />
      <TopModelsByCity />
      <WhyAutolist />
      <PhotoCredits />
      <style jsx>{`
        @media (min-width: ${screen.smMin}) {
          .ad-container {
            margin-bottom: 52px;
          }
        }
      `}</style>
      {adCSS.styles}
    </>
  );
}
